import { Component, Input, OnInit } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { InIFrame } from '../common';
import { FeatureFlagService } from '../services/featureFlag.service';
import { StorefrontService } from '../storefront.service';

@Component({
  selector: 'strfrnt-store-header',
  templateUrl: './store-header.component.html',
  styleUrls: ['./store-header.component.scss'],
  standalone: false,
})
export class StoreHeaderComponent implements OnInit {
  @Input() hideSignIn = false;

  logoURL$: Observable<string>;

  selfSignupEnabled$: Observable<boolean>;
  constructor(
    private readonly storefrontService: StorefrontService,
    private readonly featureService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.selfSignupEnabled$ = combineLatest([this.storefrontService.partnerId$, this.storefrontService.marketId$]).pipe(
      switchMap(([partnerId, marketId]) => this.featureService.isSMBSelfSignupEnabled$(partnerId, marketId)),
    );

    this.logoURL$ = this.storefrontService.logoURL$;
  }

  public signIn(goDirectRegistration: boolean): void {
    combineLatest([
      this.storefrontService.partnerId$,
      this.storefrontService.marketId$,
      this.storefrontService.packageId$,
    ])
      .pipe(take(1))
      .subscribe(([pid, mid, packageId]) => {
        if (!pid) {
          return;
        }
        mid = mid ? mid : 'default';

        // resolve URL to jump to.
        let url: string;
        if (goDirectRegistration) {
          url = `/public/business/${pid}/${mid}/sign-up`; // signup page.
        } else if (packageId) {
          url = `/account/location/default/store/${packageId}?partnerId=${pid}&marketId=${mid}`; // sort of a deep link to cart in business app.
        } else {
          url = `/account/location/default/store?partnerId=${pid}&marketId=${mid}`; // signin page.
        }

        // navigate to url
        if (InIFrame()) {
          window.open(url);
        } else {
          window.location.href = url;
        }
      });
  }
}
